import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { createUUID } from 'commons/ZimssaHelper';
import moment from 'moment';

axios.defaults.baseURL = '/api';
//axios.defaults.baseURL = 'http://127.0.0.1:3010/api';
//axios.defaults.headers['withCredentials'] = true;

const makeUUID = (storageKey: any) => {
  const newUUID = {
    createdAt: moment().format(),
    uuid: createUUID(),
  };
  window.sessionStorage.setItem(storageKey, JSON.stringify(newUUID));
  return newUUID.uuid;
};

const checkStorageItem = (storageKey: any) => {
  const storageValue = JSON.parse(
    window.sessionStorage.getItem(storageKey) as any
  );

  if (
    storageValue &&
    moment(storageValue.createdAt).isBetween(
      moment().subtract(10, 'seconds'),
      moment().add(1, 'seconds')
    )
  ) {
    // Response가 오지 않은 호출이 있음 && 10초 내의 요청이 있는 상황
    // session 업데이트 하지 않고, UUID 그대로 보내주기
    return storageValue.uuid;
  } else {
    // 10초 이상 전의 과거의 요청이 있는 상황 || 해당 키값이 없는 상황
    // session에 새로운 UUID 보내주기
    return makeUUID(storageKey);
  }
};

const deleteStorageItem = (storageKey: any) => {
  const storageValue = JSON.parse(
    window.sessionStorage.getItem(storageKey) as any
  );
  if (storageValue) {
    window.sessionStorage.removeItem(storageKey);
  }
};

axios.interceptors.request.use(
  (request: AxiosRequestConfig) => {
    const storageKey = request.url?.concat('_uuid');
    request.headers['Z-Request-ID'] = checkStorageItem(storageKey);
    return request;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response: any) => {
    const { data } = response;

    //response가 왔을 때, sessionStorage에 저장되어있는 값을 삭제해준다.
    deleteStorageItem(
      response.config.url.replace(response.config.baseURL, '').concat('_uuid')
    );

    if (data.status > 200) {
      const { errors } = data;
      let message;
      if (errors) message = errors[0].reason;
      else message = data.message;
      return {
        result: 'fail',
        message: message,
      };
    } else {
      return data;
    }
  },
  (error: any) => {
    //error가 났을때, sessionStorage에 저장되어있는 값을 삭제해준다.
    deleteStorageItem(
      error.config.url.replace(error.config.baseURL, '').concat('_uuid')
    );

    if (axios.isAxiosError(error) && error.response) {
      if (error.response.data?.message) {
        alert(error.response.data?.message);

        return Promise.reject(error);
      }
    }

    if (error instanceof Error) {
      alert(error.message);

      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default axios;
